import React, { useState } from "react";
import Results from "../../files/neuro8-fly-a-drone-results.pdf";
import {
  HeroContainer,
  HeroContent,
  HeroH1,
  HeroBtnWraper,
  Button
} from "./TechHeroElements";

const TechHero = ({ isFilterActive }) => {
  const [hover, setHover] = useState(false);

  const onHover = () => {
    setHover(!hover);
  };

  const handleButtonClick2 = (e) => {
    e.preventDefault();
    window.open(Results, '_blank', 'noopener,noreferrer');
  };

  return (
    <HeroContainer isFilterActive={isFilterActive} id="home">
      <HeroContent>
        <HeroH1>
          Fly A Drone By Thought Alone
        </HeroH1>
        <HeroBtnWraper>
          <Button
            onClick={handleButtonClick2}
            onMouseEnter={onHover}
            onMouseLeave={onHover}
            primary="true"
            dark="true"
            smooth="true"
            duration={500}
            spy="true"
            exact="true"
            offset={-80}
          >
            Download Results
          </Button>
        </HeroBtnWraper>
      </HeroContent>
    </HeroContainer>
  );
};

export default TechHero;
